import React, {useState} from 'react';
import Modal from '../../../Presentation/components/ui/Modal';
import AddProductForm from './AddProductForm';
import {useProducts} from '../hooks/useProducts';
import {useNotification} from '../../../Services/useNotification';
import StandardizedErrorHandler from '../../../Services/common/StandardizedErrorHandler';
import {useClientFeatures} from '../../../core/context/ClientContext';

interface AddProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const AddProductModal: React.FC<AddProductModalProps> = ({
  isOpen,
  onClose,
  onSuccess
}) => {
  const [submitting, setSubmitting] = useState(false);
  const {createProduct} = useProducts();
  const {success: showSuccess} = useNotification();
  const {serialsEnabled, inventoryEnabled} = useClientFeatures();

  const handleSubmit = async (formData: FormData) => {
    setSubmitting(true);
    try {
      await createProduct(formData);
      showSuccess('تم إضافة المنتج بنجاح');
      onSuccess();
      onClose();
    } catch (error: unknown) {
      StandardizedErrorHandler.getInstance().handleError(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="إضافة منتج جديد"
      width="max-w-4xl"
    >
      <div className="space-y-6">
        <div className="text-sm text-gray-600 text-center">
          أضف منتج جديد إلى النظام
        </div>

        <AddProductForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          submitting={submitting}
          allowStockChanges={inventoryEnabled}
          canEditHasSerial={serialsEnabled}
        />
      </div>
    </Modal>
  );
};

export default AddProductModal;
